import { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions";

import {
   MapContainer,
   TileLayer,
   useMap,
   Marker,
   Popup,
   Tooltip,
   SVGOverlay,
   CircleMarker,
   useMapEvent,
} from "react-leaflet";
import "./styles/karte.css";
import { MapLibreTileLayer } from "./MapLibreTileLayer";
import L from "leaflet";
import markerA from "./img/marker.webp";
import markerSquare from "./img/squaremarker.png";
import markerCircle from "./img/roundmarker.png"; /* 
import markerTriDown from "./img/triangledownmarker.png";
import markerTriUp from "./img/triangleupmarker.webp";
import markerStar from "./img/starmarker.webp"; */
import markerPin from "./img/pinMarker.webp";
import { Button } from "react-bootstrap";
import GetGeoCoords from "./GetGeoCoords";
import { useConfig } from "./ConfigContext";

export default function KarteObjekte({
   searchCoords,
   centerPin,
   myMap,
   setMyMap,
   userObjects,
   estates,
   selectedUser,
   setSelectedUser,
   frameStyle,
}) {
   const animateRef = useRef(false);
   const config = useConfig();

   const iconA = new L.Icon({
      iconUrl: markerA,
      iconRetinaUrl: markerA,
      popupAnchor: [-0, -0],
      iconSize: [32, 45],
      className: "custommarker",
   });

   const iconB = new L.Icon({
      iconUrl: markerPin,
      popupAnchor: [-0, -0],
      iconSize: [128, 128],
      className: "hue-rotate-240",
   });
   const iconPin = new L.Icon({
      iconUrl: markerPin,
      popupAnchor: [-0, -0],
      iconSize: [128, 128],
   });

   const center = config.standorte.center.coords; //[48.069127679996505, 9.78794715586747];

   return (
      <>
         <div className="mapframe" style={frameStyle}>
            <div style={{ position: "absolute", right: 0, zIndex: 10, margin: "20px" }}>
               {selectedUser && (
                  <Button
                     variant="dark"
                     className="me-1"
                     style={{ display: "inline" }}
                     onClick={() => setSelectedUser(false)}
                  >
                     Alle anzeigen
                  </Button>
               )}
            </div>
            <MapContainer
               center={center ? center : [47.807276048680215, 9.63688394923563]}
               zoom={9}
               zoomSnap={0.1}
               ref={setMyMap}
               wheelPxPerZoomLevel={160}
               zoomControl={false}
               scrollWheelZoom={true} /*  attributionControl={false} */
            >
               {/* <MapLibreTileLayer
                  url="https://tiles.stadiamaps.com/styles/alidade_smooth_dark.json"
               /> */}
               <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
               {Object.keys(config.standorte).map((item) => (
                  <Marker icon={iconA} position={config.standorte[item].coords}></Marker>
               ))}
               {estates
                  .filter((item) => (selectedUser ? selectedUser === item.benutzer : true))
                  .map((item, index) => {
                     let longlat = [parseFloat(item?.breitengrad || 0), parseFloat(item?.laengengrad || 0)];

                     let myPathOptions = { color: "black", weight: 0, fillOpacity: 0.01 };
                     let myStyle = {
                        padding: "4px 8px",
                        borderRadius: "16px",
                        backgroundColor: userObjects[item.benutzer] ? userObjects[item.benutzer].color : "#000",
                     };

                     if (selectedUser && config.verkaufsStatusFarben[item.status2]) {
                        myStyle["backgroundColor"] = config.verkaufsStatusFarben[item.status2]?.color ?? "#909";
                        // myStyle["color"]="#000"
                     }
                     let showMarker = true;

                     return (
                        <>
                           {showMarker && (
                              <CircleMarker center={longlat} radius={20} pathOptions={myPathOptions}>
                                 <Tooltip direction="center" offset={[0, 0]} opacity={1} permanent>
                                    <div
                                       style={{
                                          ...myStyle,
                                       }}
                                    >
                                       {userObjects && (
                                          <span>{userObjects[item.benutzer]?.Kuerzel ?? item.benutzer}</span>
                                       )}
                                    </div>
                                 </Tooltip>
                                 <Popup offset={[0, -10]}>
                                    <div>
                                       <h5>{item[config.estate.objektBezeichnung] ?? item.objektnr_extern}</h5>

                                       <br />

                                       <br />
                                       <Button onClick={() => setSelectedUser(item.benutzer)} className="me-1">
                                          nur {userObjects[item.benutzer]?.Name ?? item.benutzer} anzeigen
                                       </Button>
                                       <a
                                          className="btn btn-outline-primary"
                                          href={"/datenblatt?estateid=" + item.id}
                                          target="_blank"
                                       >
                                          {item.objektnr_extern} ↗
                                       </a>
                                    </div>
                                 </Popup>
                              </CircleMarker>
                           )}
                        </>
                     );
                  })}
               {centerPin && <Marker icon={iconPin} position={centerPin}></Marker>}
               {searchCoords && (
                  <Marker icon={iconB} position={[searchCoords?.lat ?? 0, searchCoords?.lon ?? 0]}></Marker>
               )}
            </MapContainer>
         </div>
      </>
   );
}
